import { render, staticRenderFns } from "./MarketingHeader.vue?vue&type=template&id=2a167bbf&"
import script from "./MarketingHeader.vue?vue&type=script&lang=js&"
export * from "./MarketingHeader.vue?vue&type=script&lang=js&"
import style0 from "./MarketingHeader.vue?vue&type=style&index=0&id=2a167bbf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports